import { Component, inject } from '@angular/core'

import { ReferencesComponent } from '../../../../../../../modules/shared/components/references/references.component'
import { PackageViewService } from '../../../../../services/reader/package-view.service'

@Component({
  standalone: true,
  selector: 'default-references-tab',
  imports: [ReferencesComponent],
  templateUrl: './references-tab.component.html',
  styleUrls: ['./references-tab.component.scss'],
})
export class ReferencesTabComponent {
  private readonly pkgView = inject(PackageViewService)

  readonly pkg = this.pkgView.activePackage
}
